import {Component, OnInit} from '@angular/core';

import {OktaAuthService} from "@okta/okta-angular";
import {Router} from "@angular/router";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  constructor(private oktaAuth: OktaAuthService, private router: Router
    , private http: HttpClient) {
  }

  loading = true;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  company: string;
  brokerId: string;
  salesPerson: string

  ngOnInit(): void {

    this.oktaAuth.getUser().then(data => {
      this.email = data.email;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.phone = data.phone;
      this.company = data.company;
      this.brokerId = data.brokerId;
      this.salesPerson = data.salesPerson;
      this.loading = false;

    })
  }


  logout() {
    this.oktaAuth.signOut()
    window.location.href = '/login';

  }


}
